import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Eyebrow } from "@/components/ui-kit/Kit";
import { MaskLines, Reveal } from "@/components/motion/Reveal";

export const PageHero = ({ eyebrow, title, lead, crumb }) => (
  <section className="relative overflow-hidden bg-navy-deep pb-20 pt-16 text-white grain sm:pb-28 sm:pt-24" data-testid="page-hero">
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 hairline-grid" />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-20 -top-20 h-[380px] w-[380px] rounded-full bg-grn/10 blur-[130px]"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-24 -top-10 hidden w-[380px] opacity-[0.12] lg:block"
    >
      <img src="/gpu-logo-t-512.webp" alt="" className="h-auto w-full" loading="lazy" />
    </div>
    <div className="relative container">
      <nav aria-label="Breadcrumb" className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
        <Link to="/" className="hover:text-gold">
          Home
        </Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-white/70">{crumb || title}</span>
      </nav>

      <div className="mt-10">
        <Eyebrow tone="gold">{eyebrow}</Eyebrow>
      </div>
      <h1 className="mt-6 max-w-[24ch] font-display text-[clamp(2.1rem,5.4vw,4.2rem)] font-bold leading-[1.02] tracking-[-0.028em]">
        <MaskLines lines={[title]} delay={0.1} />
      </h1>
      {lead && (
        <Reveal delay={0.35}>
          <p className="mt-8 max-w-2xl border-l border-gold/40 pl-6 text-sm leading-relaxed text-white/65 sm:text-base">
            {lead}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);
